import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/pc/btn_gf.png'
import _imports_1 from '@/assets/images/pc/btn_readmore.png'


const _hoisted_1 = { class: "news-page" }
const _hoisted_2 = { class: "news-list" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  alt: "",
  class: "cover"
}
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "right-top" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "big-title" }, [
      _createElementVNode("span", null, "NEWS")
    ], -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
              [_directive_lazy, require('@/assets/images/'+item.coverImg)]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.time), 1)
            ]),
            _createElementVNode("div", {
              class: "introduce",
              innerHTML: item.introduce
            }, null, 8, _hoisted_9),
            (item.isShowBtn)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: "_blank",
                  href: item.btnUrl,
                  class: "btn-box"
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ]))], 8, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    (!$setup.isShowMore)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "readMoreBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showMore()))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}